import { IconLink } from '#app/components/Footer/constants.js';
import {
  SocialInstagramIcon,
  SocialPinterestIcon,
  SocialTiktokIcon,
  SocialTwitterIcon,
  SocialYoutubeIcon,
} from '@contra/icons/icons';

export const NAVBAR_HEIGHT = 64;

export const NAVBAR_PROMOTIONAL_BANNER_HEIGHT = 72;

export const NAVBAR_INFORMATIONAL_BANNER_HEIGHT = 68;

export const SOCIAL_LINKS: IconLink[] = [
  {
    icon: <SocialTiktokIcon size={24} />,
    label: 'TikTok',
    link: 'https://tiktok.com/@contrahq',
  },
  {
    icon: <SocialTwitterIcon size={24} />,
    label: 'Twitter',
    link: 'https://twitter.com/contra',
  },
  {
    icon: <SocialInstagramIcon size={24} />,
    label: 'Instagram',
    link: 'https://instagram.com/contra',
  },
  {
    icon: <SocialYoutubeIcon size={24} />,
    label: 'Youtube',
    link: 'https://www.youtube.com/@contra4046',
  },
  {
    icon: <SocialPinterestIcon size={24} />,
    label: 'Pinterest',
    link: 'https://www.pinterest.com/contrahq',
  },
];
